module.exports = __webpack_public_path__ + "./img/delete.47c71bac889a99d8b27aea4ca33e682a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/delete.png
// module id = ./assets/images/delete.png
// module chunks = 0